import { FunctionComponent } from "react";
import { Step } from "@App/Components/Stepper/Step";
import { LocationStep } from "@App/Components/molecules/whitelabel/home/stepper/LocationStep";
import { ChildStepProps } from "@App/Components/molecules/whitelabel/home/stepDefinitions/ChildStepProps";

type LocationStepDefinitionProps = {
  onSubmit: () => void;
  stepTitle: string;
  stepGoBackLinkTitle: string;
  error: string | null;
  button: {
    text: string;
  };
} & ChildStepProps;

export const LocationStepDefinition: FunctionComponent<LocationStepDefinitionProps> = ({
  onSubmit,
  stepTitle,
  stepGoBackLinkTitle,
  error,
  button,
  ...stepProps
}: LocationStepDefinitionProps) => {
  return (
    <Step
      {...stepProps}
      title={stepTitle}
      completedTitle={""}
      completedGoBackLinkTitle={stepGoBackLinkTitle}
    >
      <LocationStep submit={onSubmit} button={button} error={error} />
    </Step>
  );
};
